export default __webpack_public_path__ + "static/media/hero-480w.8ff50057.png";